var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 9,
  width: 6,
  height: 6,
  rx: 2,
  fill: "#FF5D5D"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 9,
  width: 6,
  height: 6,
  rx: 2,
  fill: "#00C896"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 9,
  width: 6,
  height: 6,
  rx: 2,
  fill: "#FDA633"
})));
export default __webpack_public_path__ + "static/media/qualityCheck.878ab2f2.svg";
export { SvgComponent as ReactComponent };